<template>
  <v-container class="mb-12">
    <v-flex>
      <v-layout justify-center>
        <Logo></Logo>
      </v-layout>

      <h1 class="text-center mb-4">Contact Us</h1>

      <v-layout align-center column>
        <h1 class="title mb-1">We love feedback! Please write an email to:</h1>
        <a href="mailto:uelling@viveritatx.com">uelling@viveritatx.com</a>
        <a href="mailto:johannes.zuber@imp.ac.at">johannes.zuber@imp.ac.at</a>
      </v-layout>
    </v-flex>
  </v-container>
</template>

<script>
  import Logo from '../components/Logo';

  export default {
    name: 'Contact',
    components: {
      Logo
    },
    data() {
      return {
      }
    }
  }
</script>

<style scoped>

</style>